export const MAX_CONDITION_IMAGE_DIMENSION = 1600;
const MAX_STORED_IMAGE_BYTES = 1024 * 1024;
const MAX_SOURCE_IMAGE_BYTES = 30 * 1024 * 1024;

export const resizeConditionImage = (file) => new Promise((resolve, reject) => {
  if (!file || !file.type?.startsWith('image/')) {
    reject(new Error('Please select an image file'));
    return;
  }
  if (file.size > MAX_SOURCE_IMAGE_BYTES) {
    reject(new Error('Please select an image smaller than 30 MB'));
    return;
  }

  const reader = new FileReader();
  reader.onerror = () => reject(new Error('The image could not be read'));
  reader.onload = () => {
    const image = new Image();
    image.onerror = () => reject(new Error('The selected image format is not supported'));
    image.onload = () => {
      const longestSide = Math.max(image.naturalWidth, image.naturalHeight);
      const scale = Math.min(1, MAX_CONDITION_IMAGE_DIMENSION / longestSide);
      const width = Math.max(1, Math.round(image.naturalWidth * scale));
      const height = Math.max(1, Math.round(image.naturalHeight * scale));
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d');
      if (!context) {
        reject(new Error('The image could not be processed'));
        return;
      }
      context.drawImage(image, 0, 0, width, height);
      for (const quality of [0.85, 0.7, 0.55, 0.4, 0.3, 0.2]) {
        const dataUrl = canvas.toDataURL('image/jpeg', quality);
        const base64Length = dataUrl.length - dataUrl.indexOf(',') - 1;
        const decodedBytes = Math.floor(base64Length * 3 / 4);
        if (decodedBytes <= MAX_STORED_IMAGE_BYTES) {
          resolve(dataUrl);
          return;
        }
      }
      reject(new Error('The resized image is still too large to upload'));
    };
    image.src = reader.result;
  };
  reader.readAsDataURL(file);
});
